import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.companyListing || initialState;

export const selectCompanies = createSelector(
  [selectDomain],
  (state) => state.companies
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectCompanyCount = createSelector(
  [selectDomain],
  (state) => state.companyCount
);

export const selectTotalCompanies = createSelector(
  [selectDomain],
  (state) => state.totalCompanies
);
